module.exports = __webpack_public_path__ + "img/intruction-mobile.0014ca89.png";